/** @format */

export const ID_ROOT = 'detailed-root';
export const ID_PAY_CARD = 'pay-card';
export const ID_PAY_BILL = 'pay-bill';
export const ID_BADGE = 'badge';
export const ID_OLD_MONTH = 'old-month';
export const ID_OLD_TOTAL = 'old-total';
export const ID_PARTNER_DISCOUNT = 'partner-discount';
